import * as S from './styles';

import { MediaMatch } from '../../../MediaMatch';
import { Skeleton } from '../../../Skeleton';
import { Typography } from '../../../Typography';

import { formatGtm } from '../../../../../utils/formatGtm';

import { CardTertiaryProps } from './types';

export const CardTertiary = ({
	tertiaryCardTitle = 'Autorável: até 27 caracteres',
	tertiaryCardLinkUrlOne = 'https://www.portoseguro.com.br/',
	tertiaryCardExternalLinkOne = true,
	tertiaryCardDescriptionOne = '16 caracteres',
	tertiaryCardImageOne = 'https://via.placeholder.com/160x121',
	tertiaryCardLinkUrlTwo = 'https://www.portoseguro.com.br/',
	tertiaryCardExternalLinkTwo = true,
	tertiaryCardDescriptionTwo = '16 caracteres',
	tertiaryCardImageTwo = 'https://via.placeholder.com/160x121',
	tertiaryCardLinkUrlThree = 'https://www.portoseguro.com.br/',
	tertiaryCardExternalLinkThree = true,
	tertiaryCardDescriptionThree = '16 caracteres',
	tertiaryCardImageThree = 'https://via.placeholder.com/240x121',
	tertiaryCardLinkUrlFour = 'https://www.portoseguro.com.br/',
	tertiaryCardExternalLinkFour = true,
	tertiaryCardDescriptionFour = '16 caracteres',
	tertiaryCardImageFour = 'https://via.placeholder.com/240x121',
	tertiaryCardLinkUrl = 'https://www.portoseguro.com.br/',
	tertiaryCardExternalLink = true,
	mode = 'light',
	tertiaryCardLinkDescription = 'Até 30 caracteres',
	isLoading = false,
	headingCardTertiary,
	headingCardTertiaryProduct1,
	headingCardTertiaryProduct2,
	headingCardTertiaryProduct3,
	headingCardTertiaryProduct4,
	gtmName,
}: CardTertiaryProps) => {
	function handleClick(url: string, target: boolean) {
		window.open(url, target ? '_blank' : '_self');
	}
	return (
		<>
			{isLoading ? (
				<>
					<MediaMatch lessThan="desktop">
						<S.Container data-id="card-product" mode={mode}>
							<S.TitleCard tabIndex={0}>
								<Skeleton width={100} height={3.4} />
							</S.TitleCard>
							<S.ItemCombo>
								<S.ComboContainer mode={mode}>
									<S.TitleText>
										<Skeleton width={100} height={1.5} />
									</S.TitleText>
									<Skeleton width={100} height={12.1} borderRadius={1.6} />
								</S.ComboContainer>
								<S.ComboContainer mode={mode}>
									<S.TitleText>
										<Skeleton width={100} height={1.5} />
									</S.TitleText>
									<Skeleton width={100} height={12.1} borderRadius={1.6} />
								</S.ComboContainer>
								<S.ComboContainer mode={mode}>
									<S.TitleText>
										<Skeleton width={100} height={1.5} />
									</S.TitleText>
									<Skeleton width={100} height={12.1} borderRadius={1.6} />
								</S.ComboContainer>
								<S.ComboContainer mode={mode}>
									<S.TitleText>
										<Skeleton width={100} height={1.5} />
									</S.TitleText>
									<Skeleton width={100} height={12.1} borderRadius={1.6} />
								</S.ComboContainer>
							</S.ItemCombo>
							<Skeleton width={100} height={2.6} />
						</S.Container>
					</MediaMatch>
					<MediaMatch greaterThan="desktop">
						<S.Container data-id="card-product" mode={mode}>
							<S.TitleCard tabIndex={0}>
								<Skeleton width={100} height={2.6} />
							</S.TitleCard>
							<S.ItemCombo>
								<S.ComboContainer mode={mode}>
									<S.TitleText>
										<Skeleton width={100} height={2.2} />
									</S.TitleText>
									<Skeleton width={100} height={12.2} borderRadius={1.6} />
								</S.ComboContainer>
								<S.ComboContainer mode={mode}>
									<S.TitleText>
										<Skeleton width={100} height={2.2} />
									</S.TitleText>
									<Skeleton width={100} height={12.2} borderRadius={1.6} />
								</S.ComboContainer>
								<S.ComboContainer mode={mode}>
									<S.TitleText>
										<Skeleton width={100} height={2.2} />
									</S.TitleText>
									<Skeleton width={100} height={12.2} borderRadius={1.6} />
								</S.ComboContainer>
								<S.ComboContainer mode={mode}>
									<S.TitleText>
										<Skeleton width={100} height={2.2} />
									</S.TitleText>
									<Skeleton width={100} height={12.2} borderRadius={1.6} />
								</S.ComboContainer>
							</S.ItemCombo>
							<Skeleton width={100} height={2.2} />
						</S.Container>
					</MediaMatch>
				</>
			) : (
				<S.Container role="card-tertiary" data-id="card-product" mode={mode}>
					<Typography
						as={headingCardTertiary}
						type="Title6"
						weight="medium"
						color="portoSeguros100"
						style={{ paddingBottom: '27px' }}
					>
						{tertiaryCardTitle}
					</Typography>

					<S.ItemCombo>
						<S.Link
							href={tertiaryCardLinkUrlOne}
							target={tertiaryCardExternalLinkOne ? '_blank' : '_self'}
							tabIndex={0}
							role="card-tertiary-link-url-one"
							rel="noreferrer"
							data-gtm-type="click"
							data-gtm-clicktype="card"
							data-gtm-name={formatGtm(gtmName)}
							data-gtm-subname={`${formatGtm(tertiaryCardTitle)}:${formatGtm(
								tertiaryCardDescriptionOne
							)}`}
							onClick={() =>
								handleClick(
									tertiaryCardLinkUrlOne!,
									tertiaryCardExternalLinkOne!
								)
							}
						>
							<S.ComboContainer mode={mode}>
								<Typography
									as={headingCardTertiaryProduct1}
									type="Body1"
									weight="regular"
								>
									{tertiaryCardDescriptionOne}
								</Typography>
								<S.Image
									loading="lazy"
									src={tertiaryCardImageOne}
									alt={tertiaryCardDescriptionOne}
									width={304}
									height={412}
								/>
							</S.ComboContainer>
						</S.Link>
						<S.Link
							href={tertiaryCardLinkUrlTwo}
							target={tertiaryCardExternalLinkTwo ? '_blank' : '_self'}
							tabIndex={0}
							role="card-tertiary-link-url-two"
							rel="noreferrer"
							data-gtm-type="click"
							data-gtm-clicktype="card"
							data-gtm-name={formatGtm(gtmName)}
							data-gtm-subname={`${formatGtm(tertiaryCardTitle)}:${formatGtm(
								tertiaryCardDescriptionTwo
							)}`}
							onClick={() =>
								handleClick(
									tertiaryCardLinkUrlTwo!,
									tertiaryCardExternalLinkTwo!
								)
							}
						>
							<S.ComboContainer mode={mode}>
								<Typography
									as={headingCardTertiaryProduct2}
									type="Body1"
									weight="regular"
								>
									{tertiaryCardDescriptionTwo}
								</Typography>
								<S.Image
									loading="lazy"
									src={tertiaryCardImageTwo}
									alt={tertiaryCardDescriptionTwo}
									width={304}
									height={412}
								/>
							</S.ComboContainer>
						</S.Link>
						<S.Link
							href={tertiaryCardLinkUrlThree}
							target={tertiaryCardExternalLinkThree ? '_blank' : '_self'}
							tabIndex={0}
							role="card-tertiary-link-url-three"
							rel="noreferrer"
							data-gtm-type="click"
							data-gtm-clicktype="card"
							data-gtm-name={formatGtm(gtmName)}
							data-gtm-subname={`${formatGtm(tertiaryCardTitle)}:${formatGtm(
								tertiaryCardDescriptionThree
							)}`}
							onClick={() =>
								handleClick(
									tertiaryCardLinkUrlThree!,
									tertiaryCardExternalLinkThree!
								)
							}
						>
							<S.ComboContainer mode={mode}>
								<Typography
									as={headingCardTertiaryProduct3}
									type="Body1"
									weight="regular"
								>
									{tertiaryCardDescriptionThree}
								</Typography>
								<S.Image
									loading="lazy"
									src={tertiaryCardImageThree}
									alt={tertiaryCardDescriptionThree}
									width={304}
									height={412}
								/>
							</S.ComboContainer>
						</S.Link>
						<S.Link
							href={tertiaryCardLinkUrlFour}
							target={tertiaryCardExternalLinkFour ? '_blank' : '_self'}
							tabIndex={0}
							role="card-tertiary-link-url-four"
							rel="noreferrer"
							data-gtm-type="click"
							data-gtm-clicktype="card"
							data-gtm-name={formatGtm(gtmName)}
							data-gtm-subname={`${formatGtm(tertiaryCardTitle)}:${formatGtm(
								tertiaryCardDescriptionFour
							)}`}
							onClick={() =>
								handleClick(
									tertiaryCardLinkUrlFour!,
									tertiaryCardExternalLinkFour!
								)
							}
						>
							<S.ComboContainer mode={mode}>
								<Typography
									as={headingCardTertiaryProduct4}
									type="Body1"
									weight="regular"
								>
									{tertiaryCardDescriptionFour}
								</Typography>
								<S.Image
									loading="lazy"
									src={tertiaryCardImageFour}
									alt={tertiaryCardDescriptionFour}
									width={304}
									height={412}
								/>
							</S.ComboContainer>
						</S.Link>
					</S.ItemCombo>
					<S.CTALink
						href={tertiaryCardLinkUrl}
						target={tertiaryCardExternalLink ? '_blank' : '_self'}
						tabIndex={0}
						role="card-tertiary-link-url"
						data-gtm-type="click"
						data-gtm-clicktype="card"
						data-gtm-name={formatGtm(gtmName)}
						data-gtm-subname={`${formatGtm(tertiaryCardTitle)}:${formatGtm(
							tertiaryCardLinkDescription
						)}`}
						rel="noreferrer"
						onClick={() =>
							handleClick(tertiaryCardLinkUrl!, tertiaryCardExternalLink!)
						}
					>
						{tertiaryCardLinkDescription}
					</S.CTALink>
				</S.Container>
			)}
		</>
	);
};
